<app-unified-print
  [profile]="data.profile"
  [appStatus]="data.appStatus"
  [silentPrint]="data.silentPrint"
  (closeDialog)="closeModal($event)"
/>
